import React, { PropsWithChildren } from "react";

/**
 * Use this instead of "useless" fragments to avoid upsetting the linter
 */
export const EmptyWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
